import { render, staticRenderFns } from "./PointPassport.vue?vue&type=template&id=6647afca&scoped=true"
import script from "./PointPassport.vue?vue&type=script&lang=js"
export * from "./PointPassport.vue?vue&type=script&lang=js"
import style0 from "./PointPassport.vue?vue&type=style&index=0&id=6647afca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647afca",
  null
  
)

export default component.exports